import { jwtDecode } from "jwt-decode";
import { TokenDecrypt } from "../../utils/encryptionDecryption";
import { loginFromServer } from "../../services/AuthService";
import { setSessionItemFunction } from "../../utils/getAreaId";

export const login = async (loginId, password, navigate, toastRef) => {
  try {
    const encryptedData = await loginFromServer(loginId, password);
    setSessionItemFunction("entireToken", encryptedData);
    const loggedUserToken = TokenDecrypt(encryptedData);
    const decodedidToken = jwtDecode(loggedUserToken.idToken);
    const {
      stateName, districtName, districtId, talukaId, stateId,
      talukaName, phcName, subcenterName, phcId, areaId, accessMenus,
      access_level_id, corporation_council_id, lgbId, name, refreshToken,
      userRole, idToken, firstname, lastname, rolename
    } = loggedUserToken;
    const usercode = decodedidToken["custom:Usercode"];
    const sessionData = {
      stateName, phcName, subcenterName, districtId, stateId, talukaId,
      districtName, talukaName, phcId, areaId, accessMenus, access_level_id,
      corporation_council_id, lgbId, name, refreshToken, userToken: idToken,
      userRole, firstname, lastname, rolename
    };
    Object.keys(sessionData).forEach((key) => {
      setSessionItemFunction(key, sessionData[key]);
    });
    toastRef.current.show({
      severity: "success",
      summary: "Welcome Back!",
      detail: "You have successfully logged in.",
      life: 1500,
    });
    setTimeout(() => {
      navigate("/dashboard");
      window.location.reload(); 
    }, 1300);
  } catch (error) {
    toastRef.current.show({
      severity: "error",
      summary: "Login Failed",
      detail: "Please check your credentials",
      life: 1500,
    });
  }
};